import { Button, Checkbox, Col, Descriptions, Modal, Row, Tag } from 'antd'
import { AppContext } from 'AppContext'

import React, { useContext, useEffect, useState } from 'react'
import { useQuery } from '@apollo/react-hooks'
import { GET_USER_ANSWERS } from '../graphql/Queries'
import {
  GET_PLANS_BASED_POINTS,
  GET_QUESTIONS,
} from 'modules/Questionnaires/graphql/Query'
import client from 'apollo'
import { UPDATE_USER } from 'modules/Users/graphql/Mutations'
import { ADD_SUMMARY_UI, GIVE_ANSWER } from '../graphql/Mutations'
import RiskProfileNew from '.'
import { Steps } from 'antd'
// import InvestmentPlanningNew from '../InvestmentPlanningNew'
import NewSummaryUIModal from './newSummaryUIModal'
import AgreementSign from '../AgreementSignNew'
import checkCircleForStep from 'assets/images/new-images/checkCircleForStep.svg'
import moment from 'moment'
const RiskProfileYearlyPopUp = ({ isVisible, setIsVisible }) => {
  const {
    dispatch,
    state: { isMobile, currentUser, clientRiskScore },
  } = useContext(AppContext)
  const currentUserPlanId = currentUser?.planId || currentUser?.plan?.id
  const { Step } = Steps
  const [agree, setAgree] = useState(false)
  const [confirmLoading, setConfirmLoading] = useState(false)
  const [reevaluateLoading, setReevaluateLoading] = useState(false)
  const [filteredAnswers, setFilteredAnswers] = useState([])
  const [effectiveAnswers, setEffectiveAnswers] = useState([])
  const [showAgreement, setShowAgreement] = useState(JSON.parse(currentUser?.toShowAgreement)?.toShowAgreement)
  const [current, setCurrent] = useState(0)
  //const [showSummary, setShowSummary] = useState(currentUser?.showSummary)
  const showSummary = currentUser?.showSummary

  const { data: userAnswers } = useQuery(GET_USER_ANSWERS, {
    variables: { where: { planName: 'Power Booster Plan' } },
    fetchPolicy: 'network-only',
  })
  const { data: questions } = useQuery(GET_QUESTIONS, {
    fetchPolicy: 'network-only',
  })

  useEffect(() => {
    const pbAnswers = userAnswers?.getUserAnswers || []
    if (pbAnswers.length) {
      setEffectiveAnswers(pbAnswers)
      return
    }

    // Keep Power Booster as primary source; fallback only to avoid empty modal.
    client
      .query({
        query: GET_USER_ANSWERS,
        variables: { where: {} },
        fetchPolicy: 'network-only',
      })
      .then((res) => {
        setEffectiveAnswers(res?.data?.getUserAnswers || [])
      })
      .catch(() => {
        setEffectiveAnswers([])
      })
  }, [userAnswers])

  useEffect(() => {
    setShowAgreement(JSON.parse(currentUser?.toShowAgreement)?.toShowAgreement)
  }, [currentUser])
  useEffect(() => {
    const filteredData = effectiveAnswers
      ?.filter((userAnswer) =>
        questions?.getQuestions?.some(
          (question) => question.id === userAnswer.question.id
        )
      )
      ?.map((userAnswer) => {
        const matchingQuestion = questions?.getQuestions?.find(
          (question) => question.id === userAnswer.question.id
        )
        return {
          ...userAnswer,
          questionText: matchingQuestion?.question,
        }
      })
    setFilteredAnswers(filteredData)
  }, [questions, effectiveAnswers])

  const renderItem = (question, answer, isHeading = false) => {
    return (
      <Descriptions.Item
        span={3}
        style={{ backgroundColor: isHeading ? '#f2f2f2' : '' }}
      >
        <Row>
          <Col
            style={{
              padding: `${isMobile ? '0 4px' : '0 16px'}`,
              textWrap: 'balance',
            }}
            span={15}
          >
            {question.question}
          </Col>
          <Col
            style={{
              padding: `${isMobile ? '0 0px' : '0 16px'}`,
              textWrap: 'wrap',
            }}
            span={9}
          >
            {answer}
          </Col>
        </Row>
      </Descriptions.Item>
    )
  }
  const handleAgree = (e) => {
    setAgree(e.target.checked)
  }
  const onConfirm = () => {
    client
      .mutate({
        mutation: UPDATE_USER,
        variables: {
          data: {
            toShowAgreement: JSON.stringify({
              isFromConfirm: true,
              toShowAgreement: false,
            }),
          },
          id: currentUser?.id,
        },
      })
      .then((res) => {
        dispatch({
          type: 'CURRENT_USER',
          data: res.data.updateUser,
        })
        const toShowAgreement = JSON.parse(
          res.data.updateUser?.toShowAgreement
        )?.toShowAgreement

        if (toShowAgreement) {
          setShowAgreement(false)
        } else {
          setShowAgreement(true)
        }
        setConfirmLoading(true)
        const totalPoints = filteredAnswers.reduce((sum, item) => {
          const selectedOptions = JSON.parse(item.selectedOptions)
          return (
            sum + selectedOptions.reduce((acc, option) => acc + option.point, 0)
          )
        }, 0)
        let maxAUALimit = 0

        filteredAnswers.forEach((item) => {
          const selectedOptions = JSON.parse(item.selectedOptions)
          selectedOptions.forEach((option) => {
            const calculatedValue = option.value * option.multiplication
            if (calculatedValue > maxAUALimit) {
              maxAUALimit = calculatedValue
            }
          })
        })
        const currentAUA = currentUser?.exposure

        let suggestedPlans
        client
          .query({
            query: GET_PLANS_BASED_POINTS,
            variables: { points: totalPoints },
            fetchPolicy: 'network-only',
          })
          .then((res) => {
            suggestedPlans = JSON.stringify(res?.data?.fetchPlansBasedOnPoints)
            client
              .mutate({
                mutation: ADD_SUMMARY_UI,
                variables: {
                  data: {
                    riskProfileScore: parseInt(totalPoints),
                    suggestedPlans,
                    maxAUALimit: parseInt(maxAUALimit),
                    currentAUA: parseInt(currentAUA),
                  },
                },
              })
              .then((res) => {
                client
                  .mutate({
                    mutation: GIVE_ANSWER,
                    variables: {
                      data: {
                        answers: filteredAnswers.map((ques) => ({
                          questionId: parseInt(ques.question.id),
                          answer: JSON.parse(ques.selectedOptions)[0]?.option,
                          selectedOptionsId: JSON.parse(
                            ques.selectedOptions
                          ).map((opt) => opt.id),
                          planId: +currentUserPlanId || null,
                        })),
                      },
                    },
                  })
                  .then((res) => {
                    client
                      .mutate({
                        mutation: UPDATE_USER,
                        variables: {
                          data: {
                            revisedRiskButtonInfo: JSON.stringify({
                              isFromRevisedRiskProfile: true,
                              lastUpdatedDate: moment().format(),
                            }),
                            revisedRiskProfileSteps: 'SUMMARY',
                            clientScore: parseInt(totalPoints),
                          },
                          id: currentUser?.id,
                        },
                      })
                      .then((res) => {
                        dispatch({
                          type: 'CURRENT_USER',
                          data: res.data.updateUser,
                        })
                        setCurrent(1)
                      })
                  })
              })
          })
      })
  }
  const onReevaluate = () => {
    setReevaluateLoading(true)
    client
      .mutate({
        mutation: UPDATE_USER,
        variables: {
          data: {
            revisedRiskButtonInfo: JSON.stringify({
              isFromRevisedRiskProfile: true,
              lastUpdatedDate: moment().format(),
            }),
            revisedRiskProfileSteps: 'RISK_PROFILE',
            toShowAgreement: JSON.stringify({
              isFromConfirm: false,
              toShowAgreement: false,
            }),
          },
          id: currentUser?.id,
        },
      })
      .then((res) => {
        dispatch({
          type: 'CURRENT_USER',
          data: res.data.updateUser,
        })
        setCurrent(0)
      })
  }
  useEffect(() => {
    switch (currentUser?.revisedRiskProfileSteps) {
      case 'RISK_PROFILE':
        setCurrent(0)
        break
      case 'SUMMARY':
        setCurrent(1)
        break
      // case 'INVESTMENT_PLANNING':
      //   setCurrent(2)
      //   break
      case 'AGREEMENT_SIGN':
        showSummary === false ? setCurrent(1) : setCurrent(2)
        break
      case 'DONE':
        moment(currentUser?.lastRiskProfileDate).isBefore(
          moment().subtract(1, 'year')
        )
          ? setIsVisible(true)
          : JSON.parse(currentUser?.revisedRiskButtonInfo)
            ?.isFromRevisedRiskProfile
            ? setIsVisible(true)
            : setIsVisible(false)
        break
      default:
        setCurrent(0)
        break
    }
  }, [currentUser, setIsVisible, showSummary])
  const next = (nextStep = 1, isSkip = false) => {
    setCurrent(current + nextStep)
    return current + nextStep
  }
  const steps = [
    {
      title: 'Risk Profile',
      content: (
        <RiskProfileNew next={next} setShowAgreement={setShowAgreement} />
      ),
    },
    //{
    //  title: 'Summary',
    //  content: (
    //    <NewSummaryUIModal
    //      setCurrent={setCurrent}
    //      showAgreement={showAgreement}
    //    />
    //  ),
    //},
    // {
    //   title: 'Investment Planning',
    //   content: (
    //     <InvestmentPlanningNew
    //       next={next}
    //       reEvaluate={currentUser.reEvaluate}
    //     />
    //   ),
    // },
  ]
  if (showSummary) {
    steps.push({
      title: 'Summary',
      content: (
        <NewSummaryUIModal
          setCurrent={setCurrent}
          showAgreement={showAgreement}
        />
      ),
    })
  }

  if (showAgreement) {
    steps.push({
      title: "Agreement Sign",
      content: (
        <AgreementSign next={next} newEdit={showAgreement} />
      ),
    })
  }

  return (
    <Modal
      width={'80%'}
      maskClosable={false}
      closable={false}
      visible={current === 4 ? false : isVisible}
      title={
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            width: '100%',
          }}
        >
          <span>Update your risk profile details</span>
          <Button onClick={() => window.location.replace('/tickets')}>
            Create Ticket
          </Button>
        </div>
      }
    >
      {currentUser?.revisedRiskProfileSteps !== null &&
        currentUser?.revisedRiskProfileSteps !== 'DONE' ? (
        <>
          <Steps
            direction='horizontal'
            status='process'
            current={current}
            className='custom-steps'
          >
            {steps?.map((step, index) => (
              <Step
                key={index}
                title={
                  <span style={{ marginTop: '8px', display: 'block' }}>
                    {step.title}
                  </span>
                }
                icon={
                  index < current ? (
                    <img src={checkCircleForStep} alt='checkCircleForStep' />
                  ) : null
                }
              />
            ))}
          </Steps>
          {isMobile && current === 0 ? (
            <div className='user-score-status-mobile'>
              <Tag
                defaultValue={clientRiskScore}
                color='red'
                className='red-tag'
              >
                <div className='risk-score-div'>
                  <span className='risk-score-text'>Risk Score </span>
                  <span className='risk-score-total'>{clientRiskScore}</span>
                </div>
              </Tag>
              <Tag
                className={`${currentUser?.cvlStatus ? 'green-tag' : 'red-tag'
                  }`}
              >
                <div className='risk-score-div'>
                  <span
                    className={`${currentUser?.cvlStatus
                      ? 'risk-score-text-green'
                      : 'risk-score-text'
                      }`}
                  >
                    PAN KYC Status
                  </span>{' '}
                  <span
                    className={`${currentUser?.cvlStatus
                      ? 'risk-score-total-green'
                      : 'risk-score-total'
                      }`}
                  >
                    ({currentUser?.cvlStatus ? 'YES' : 'NO'})
                  </span>
                </div>
              </Tag>
            </div>
          ) : (
            current === 0 && (
              <div
                className='user-score-status'
                style={{ paddingLeft: '18px' }}
              >
                <Tag
                  defaultValue={clientRiskScore}
                  color='red'
                  className='red-tag'
                >
                  <div className='risk-score-div'>
                    <span className='risk-score-text'>Risk Score </span>
                    <span className='risk-score-total'>{clientRiskScore}</span>
                  </div>
                </Tag>
                <Tag
                  className={`${currentUser?.cvlStatus ? 'green-tag' : 'red-tag'
                    }`}
                // style={{
                //   padding: '16px',
                // }}
                >
                  <div className='risk-score-div'>
                    <span
                      className={`${currentUser?.cvlStatus
                        ? 'risk-score-text-green'
                        : 'risk-score-text'
                        }`}
                    >
                      PAN KYC Status
                    </span>{' '}
                    <span
                      className={`${currentUser?.cvlStatus
                        ? 'risk-score-total-green'
                        : 'risk-score-total'
                        }`}
                    >
                      ({currentUser?.cvlStatus ? 'YES' : 'NO'})
                    </span>
                  </div>
                </Tag>
              </div>
            )
          )}
          <div className='steps-content' style={{ marginTop: '2dvh' }}>
            {steps[current]?.content}
          </div>
        </>
      ) : (
        <>
          <Descriptions bordered className='question_detail'>
            {renderItem({ question: 'QUESTION(s)' }, 'ANSWER(s)', true)}
            {filteredAnswers?.length > 0 &&
              filteredAnswers.map((ques, ans) =>
                renderItem(
                  { question: ques?.questionText },
                  JSON.parse(ques?.selectedOptions)[0]?.option
                )
              )}
          </Descriptions>
          <br />
          <div className='agree-wrapper'>
            <Checkbox onChange={handleAgree} />
            <p className='agree-content'>
              I/We hereby declare that the details furnished above are true and
              correct to the best of my/our knowledge and belief and I/We
              undertake to inform you of any changes therein, immediately. In
              case any of the above information is found to be false or untrue
              or misleading or misrepresenting, I am/We are aware that I/We may
              be held liable for it.
            </p>
          </div>
          <div className='footer-btn-div'>
            <Button
              className='footer-cancel-btn btn-confirm'
              style={{
                backgroundColor: '#34a853',
                color: 'white',
              }}
              onClick={() => onConfirm()}
              disabled={!agree}
              loading={confirmLoading}
            >
              Confirm
            </Button>
            <Button
              loading={reevaluateLoading}
              className='footer-submit-btn'
              disabled={!agree}
              type='primary'
              onClick={() => onReevaluate()}
            >
              Re-evaluate
            </Button>
          </div>
        </>
      )}
    </Modal>
  )
}
export default RiskProfileYearlyPopUp
